var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYellowLabel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 14,
    height: 14,
    rx: 2,
    fill: "#FFEDBD"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_479_49152)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.5938 4.875L8.02748 8.44127C7.89754 8.57121 7.83257 8.63618 7.75765 8.66053C7.69174 8.68194 7.62076 8.68194 7.55485 8.66053C7.47993 8.63618 7.41496 8.57121 7.28502 8.44127L6.05873 7.21498C5.92879 7.08504 5.86382 7.02007 5.7889 6.99572C5.72299 6.97431 5.65201 6.97431 5.5861 6.99572C5.51118 7.02007 5.44621 7.08504 5.31627 7.21498L2.40625 10.125M11.5938 4.875H8.96875M11.5938 4.875V7.5",
    stroke: "#FFB800",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_479_49152"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10.5,
    height: 10.5,
    fill: "white",
    transform: "translate(1.75 2.25)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYellowLabel);
export default __webpack_public_path__ + "static/media/yellow_label.e0a66f2fc90900ccfd12ee7eb69597fe.svg";
export { ForwardRef as ReactComponent };